import { useEffect } from 'react'
import Box from '@mui/material/Box'
import { useSelector } from 'react-redux'
import { useRouter } from '@popety_io/popety-io-lib'

// import Notes from './Notes'
import { estimateSelector } from '../../redux'
import CarousselImages from './CarousselImages'
import EstimatedPrice from './EstimatedPrice'
import PriceEstimation from './PriceEstimation'
import EstimationDetails from './EstimationDetails'
import Notes from './Notes'
import EstimateFiles from './EstimateFiles'

const Summary = () => {
  const estimate = useSelector(estimateSelector)
  const { updateQuery } = useRouter()

  useEffect(() => {
    updateQuery({
      mapLg: 'noise-legend',
      tab: 'summary',
    })
  }, [])

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <CarousselImages />
      {!estimate?.showPriceGraph ? <EstimatedPrice /> : <PriceEstimation />}

      <EstimationDetails />
      {estimate?.notes && estimate?.notes.length > 0 && <Notes />}
      {estimate?.isFiles && estimate?.files?.length > 0 && <EstimateFiles />}
    </Box>
  )
}

export default Summary
